import { render, staticRenderFns } from "./DirfBeneficiario.vue?vue&type=template&id=4c960493&"
import script from "./DirfBeneficiario.vue?vue&type=script&lang=js&"
export * from "./DirfBeneficiario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports